import { useCallback, useMemo, useState } from 'react'

import { generateId } from 'core-components/helpers/generateId'

import { NOTIFICATION_PREFIX_ID, NOTIFICATIONS_COUNT_LIMIT } from '../constants'
import { IExtendedNotificationPopup } from '../models/IExtendedNotificationPopup'

export const useNotificationsQueue = () => {
  const [notifications, setNotifications] = useState<IExtendedNotificationPopup[]>([])

  const visibleNotifications = useMemo(() => {
    return notifications.slice(0, NOTIFICATIONS_COUNT_LIMIT)
  }, [notifications])

  const showNotification = useCallback((notification: IExtendedNotificationPopup) => {
    const id = notification.id || generateId(NOTIFICATION_PREFIX_ID)

    setNotifications((prev) => {
      const isNotificationExist = prev.find((el) => el.id === id)
      if (isNotificationExist) {
        return prev.map((el) => {
          if (el.id === id) {
            return notification
          }
          return el
        })
      }
      const newNotification = { ...notification, id }
      return [...prev, newNotification]
    })

    return id
  }, [])

  const closeNotification = useCallback((id: string) => {
    setNotifications((prev) => {
      const closingNotification = prev.find((el) => el.id === id)
      if (closingNotification?.onClose) {
        closingNotification.onClose()
      }
      return prev.filter((el) => el.id !== id)
    })
  }, [])

  return {
    notifications: visibleNotifications,
    showNotification,
    closeNotification,
  }
}
